import { render, staticRenderFns } from "./VoiceInput.vue?vue&type=template&id=0357135b&"
import script from "./VoiceInput.vue?vue&type=script&lang=ts&"
export * from "./VoiceInput.vue?vue&type=script&lang=ts&"
import style0 from "./VoiceInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports